module.exports = __webpack_public_path__ + "img/gas-calculator-page.de32518f.svg";